import { ContentCopy } from "@mui/icons-material";
import { IconButton, Tooltip } from "@mui/material";
import { CSSProperties } from "react";
import { TextField, useNotify, useRecordContext } from "react-admin";

type TextWithCopyProps = {
  source: string;
  displayText?: string;
  containerStyle?: CSSProperties;
  textStyle?: CSSProperties;
};

const TextWithCopy = ({ source, displayText, containerStyle, textStyle }: TextWithCopyProps) => {
  const record = useRecordContext();
  const notify = useNotify();

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(record[source]);
      notify(`${displayText || "Text"} copied to clipboard`, { type: "info" });
    } catch (err) {
      notify(`Failed to copy ${displayText || "text"}`, { type: "warning" });
    }
  };

  return (
    <span style={{ display: "inline-flex", alignItems: "center", ...containerStyle }}>
      <span style={textStyle}>
        <TextField source={source} />
      </span>
      <Tooltip title={`Copy ${displayText || "text"} to clipboard`}>
        <IconButton
          size="small"
          onClick={handleCopy}
          sx={{ ml: 0.5 }} // small left margin for spacing
        >
          <ContentCopy fontSize="inherit" />
        </IconButton>
      </Tooltip>
    </span>
  );
};

export default TextWithCopy;
